import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Tag, Typography } from 'antd'
import { FC } from 'react'

const { Text } = Typography

type Props = {
  value: boolean
}

const BooleanTag: FC<Props> = ({ value }) => {
  return (
    <Tag
      icon={value ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      color={value ? 'green' : 'red'}
    >
      <Text>{value ? 'Yes' : 'No'}</Text>
    </Tag>
  )
}

export { BooleanTag }
